// package imports
import React from 'react';

// CSS imports
import './ConfirmButton.css';

// Icon imports
import { FaCheck } from 'react-icons/fa6';

type Props = {
  className?: string;
  label?: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const ConfirmButton: React.FC<Props> = ({
  className,
  label,
  disabled,
  onClick,
}: Props) => {
  return (
    <button
      className={`ConfirmButton ${className ? className : ''}`}
      onClick={onClick}
      disabled={disabled ? disabled : undefined}
    >
      <FaCheck className={label ? 'btn-icon' : 'only-btn-icon'} />
      <b>{label ? label : null}</b>
    </button>
  );
};

export default ConfirmButton;
